export default "__VITE_ASSET__DSd6ERf9__"